import { api_POSTFile } from "./_axios";

const dreelegiveis_api =
{
    uploadDREElegiveis: function (mesAno, file) {
        const promise = new Promise((resolve, reject) => {
            api_POSTFile(`dreElegiveis/uploadDREElegiveis/${mesAno}`, file).then(resolve);
        });

        return promise;
    },
}
export default dreelegiveis_api
